<template functional>
  <div>
    <v-icon
      v-if="props.value"
      color="#FFDF3F"
    >
      star
    </v-icon>
    <v-icon v-else>
      star_border
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'DataTableHighlightRow',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
